import React, { useState } from 'react';
import { getAllTemplates, getTemplate } from '../../config/templates';
import { applyTemplate } from '../../utils/templateEngine';
import Button from '../ui/Button';
import Icon from '../AppIcon';
import TemplateCard from './TemplateCard';

const TemplateSelector = ({ currentTemplateId, onSelect, onClose }) => {
  const templates = getAllTemplates();
  const [previewId, setPreviewId] = useState(currentTemplateId);

  const handlePreview = (templateId) => {
    setPreviewId(templateId);
    const template = getTemplate(templateId);
    applyTemplate(template); // Temporary preview
  };

  const handleConfirm = () => {
    onSelect(previewId || currentTemplateId);
    onClose();
  };

  const handleCancel = () => {
    // Revert to current template
    const current = getTemplate(currentTemplateId);
    applyTemplate(current);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-1200 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card rounded-xl max-w-6xl w-full max-h-[90vh] overflow-auto shadow-romantic-2xl">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground">Choose a Template</h2>
            <p className="text-sm text-muted-foreground mt-1">Click a template to preview it</p>
          </div>
          <button
            onClick={handleCancel}
            className="w-10 h-10 rounded-full hover:bg-muted flex items-center justify-center transition-romantic"
            aria-label="Close"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-4 md:p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
            {templates.map((template) => (
              <TemplateCard
                key={template.id}
                template={template}
                selected={previewId === template.id}
                onClick={() => handlePreview(template.id)}
              />
            ))}
          </div>
        </div>

        <div className="sticky bottom-0 bg-card border-t border-border p-4 md:p-6 flex gap-3 justify-end">
          <Button variant="outline" size="lg" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="default" size="lg" onClick={handleConfirm} iconName="Check" iconPosition="left">
            Apply Template
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateSelector;
